"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FormHelperText_1 = require("@material-ui/core/FormHelperText");
var Grid_1 = require("@material-ui/core/Grid");
var TextField_1 = require("@material-ui/core/TextField");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var Forms_1 = require("src/Forms");
var paymentInputMasks_1 = require("./paymentInputMasks");
var PaymentFormFields = /** @class */ (function (_super) {
    __extends(PaymentFormFields, _super);
    function PaymentFormFields(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Get the error message for the field
         */
        _this.errorMessageForField = function (fieldName) {
            var _a = _this.props.errors, errors = _a === void 0 ? {} : _a;
            return errors[fieldName];
        };
        /**
         * Returns the class name to be applied to a field
         */
        _this.classForField = function (fieldName) {
            var errorMessage = _this.errorMessageForField(fieldName);
            return errorMessage === undefined ?
                _this.props.classes.primaryInput :
                _this.props.classes.errorInput;
        };
        /**
         * Return the error message for a given fieldName
         */
        _this.errorForField = function (fieldName) {
            var errorMessage = _this.errorMessageForField(fieldName);
            if (errorMessage === undefined) {
                return null;
            }
            else {
                return React.createElement(FormHelperText_1.default, { error: true }, errorMessage);
            }
        };
        /**
         * Format the card input
         */
        _this.onCardChange = function (e) {
            var cardInput = e.currentTarget;
            var currentValue = cardInput.value;
            _this.setState({
                cardNumber: paymentInputMasks_1.formatCreditCardNumber(currentValue)
            });
        };
        /**
         * Input the slash between expiration data values
         */
        _this.onExpirationDate = function (e) {
            var cardInput = e.currentTarget;
            var currentValue = cardInput.value;
            var _a = _this.state.expirationDate, expirationDate = _a === void 0 ? '' : _a;
            var valueLength = currentValue ? currentValue.length : 0;
            if (valueLength === 2 && expirationDate.length === 3) {
                _this.setState({ expirationDate: currentValue });
                return;
            }
            _this.setState({
                expirationDate: paymentInputMasks_1.formatExpirationDate(currentValue)
            });
        };
        _this.state = {};
        return _this;
    }
    PaymentFormFields.prototype.render = function () {
        var _a = this.props, classes = _a.classes, disabled = _a.disabled;
        return (React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.topGridItem },
            React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                React.createElement(Typography_1.default, { variant: "h5" }, "Checkout")),
            React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                React.createElement(TextField_1.default, { className: classes.fullWidth, variant: "filled", margin: "dense", label: "name on card", name: "cardholderName", placeholder: "First Last", required: true, autoComplete: "off", disabled: disabled, InputProps: { className: this.classForField('cardholderName') } }),
                this.errorForField('cardholderName')),
            React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                React.createElement(TextField_1.default, { className: classes.fullWidth, variant: "filled", margin: "dense", label: "card number", name: "number", placeholder: "1111 1111 1111 1111", required: true, autoComplete: "off", disabled: disabled, InputProps: { className: this.classForField('number') }, value: this.state.cardNumber, onChange: this.onCardChange }),
                this.errorForField('number')),
            React.createElement(Grid_1.default, { container: true, className: classes.topGridItem, direction: "row" },
                React.createElement(Grid_1.default, { item: true, className: classes.twoByChild },
                    React.createElement(TextField_1.default, { className: classes.fullWidth, variant: "filled", margin: "dense", label: "expiration date", name: "expirationDate", placeholder: "MM/YY", required: true, helperText: "MM/YY", autoComplete: "off", disabled: disabled, InputProps: { className: this.classForField('expirationDate') }, value: this.state.expirationDate, onChange: this.onExpirationDate }),
                    this.errorForField('expirationDate')),
                React.createElement(Grid_1.default, { item: true, className: classes.twoByChild },
                    React.createElement(TextField_1.default, { className: classes.fullWidth, variant: "filled", margin: "dense", label: "cvv", name: "cvv", placeholder: "111", required: true, autoComplete: "off", disabled: disabled, InputProps: { className: this.classForField('cvv') } }),
                    this.errorForField('cvv')))));
    };
    return PaymentFormFields;
}(React.Component));
exports.default = withStyles_1.default(Forms_1.styles)(PaymentFormFields);
